import CampaignIcon from "@mui/icons-material/Campaign";
import { Box } from "@mui/material";

// @ts-ignore
import type { SearchMessageResult } from "@storyboard/web-client";
import { sanitizeHtmlForDisplay } from "@/utils/sanitizeHtmlForDisplay";

export default function PodcastItem({ message }: { message: SearchMessageResult }) {
  return (
    <Box>
      <Box className="podcast-header">
        <Box className="podcast-icon">
          <CampaignIcon />
        </Box>
        <Box>
          {message?.displayTitle?.length > 0 && (
            <Box
              dangerouslySetInnerHTML={{
                __html: sanitizeHtmlForDisplay(message.displayTitle ?? ""),
              }}
            />
          )}
        </Box>
      </Box>
      {message?.displayDescription?.length > 0 && (
        <Box
          dangerouslySetInnerHTML={{
            __html: sanitizeHtmlForDisplay(message.displayDescription ?? ""),
          }}
        />
      )}
    </Box>
  );
}
